import { BaseTool } from '../BaseTool';

export class SnapsTool extends BaseTool {
    id = 'MANAGE_SNAPS';
    name = 'Snaps';
    cursor = 'default';

    onActivate(): void {
        this.context?.appStore.openManageDialog('snaps');
        this.context?.appStore.setActiveTool('select');
    }

    onPointerDown(): void { }
    onPointerMove(): void { }
    onPointerUp(): void { }
}
